import { BusEvent } from '@web/common';

export class AdminCosmeticChangedBusEvent extends BusEvent {}
